import { CalendarClock, Bell, Megaphone, MessagesSquare } from 'lucide-react'

function moeda(valor, currency = 'BRL') {
  return Number(valor || 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency,
  })
}

function Card({ icon: Icon, titulo, count, cost, currency, nota }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 flex flex-col gap-1">
      <div className="flex items-center gap-2 text-gray-600">
        <Icon className="w-4 h-4" />
        <span className="text-sm">{titulo}</span>
      </div>
      <p className="text-xl font-semibold text-gray-900">
        {moeda(cost, currency)}
      </p>
      <p className="text-xs text-gray-500">
        {Number(count || 0).toLocaleString('pt-BR')} mensagens
        {nota ? ` · ${nota}` : ''}
      </p>
    </div>
  )
}

export function Usage({ usage }) {
  return (
    <div className="flex flex-col gap-3 w-full">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900">Consumo do mês</h3>
        {usage.updatedAt && (
          <span className="flex items-center gap-1 text-xs text-gray-500">
            <CalendarClock className="w-3.5 h-3.5" />
            atualizado em{' '}
            {new Date(usage.updatedAt).toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        )}
      </div>

      <div className="grid gap-3 sm:grid-cols-3">
        <Card
          icon={Bell}
          titulo="Lembretes"
          count={usage.utility?.count}
          cost={usage.utility?.cost}
          currency={usage.currency}
        />
        <Card
          icon={Megaphone}
          titulo="Promoções"
          count={usage.marketing?.count}
          cost={usage.marketing?.cost}
          currency={usage.currency}
        />
        <Card
          icon={MessagesSquare}
          titulo="Conversas"
          count={usage.service?.count}
          cost={usage.service?.cost}
          currency={usage.currency}
          nota="1.000 grátis/mês"
        />
      </div>

      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 flex items-center justify-between">
        <span className="text-sm text-gray-700">Total estimado no mês</span>
        <span className="text-lg font-semibold text-gray-900">
          {moeda(usage.totalCost, usage.currency)}
        </span>
      </div>

      <p className="text-xs text-gray-500">
        Valores aproximados, informados pela Meta. A cobrança oficial e o
        comprovante ficam na sua conta Meta.
      </p>
    </div>
  )
}
